import type { AppLocale } from "./types";

const DEFAULT_TIMEZONE = "UTC";

const DATETIME_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

export function bcp47Locale(locale: AppLocale): string {
  return locale === "en" ? "en-US" : "zh-CN";
}

export function resolveTimezone(timezone: string | undefined): string {
  const candidate = timezone?.trim() || DEFAULT_TIMEZONE;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: candidate }).format(0);
    return candidate;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}

export function formatDateTime(
  value: unknown,
  locale: AppLocale,
  timezone: string,
  fallback = "",
): string {
  if (value == null || value === "") return fallback;
  const date = value instanceof Date
    ? value
    : new Date(typeof value === "number" ? value : Date.parse(String(value)));
  if (Number.isNaN(date.getTime())) return typeof value === "string" ? value : fallback;
  try {
    return new Intl.DateTimeFormat(bcp47Locale(locale), {
      ...DATETIME_OPTIONS,
      timeZone: resolveTimezone(timezone),
    }).format(date);
  } catch {
    return typeof value === "string" ? value : fallback;
  }
}

export function hourInTimezone(date: Date, timezone: string): number {
  const hour = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hourCycle: "h23",
    timeZone: resolveTimezone(timezone),
  }).formatToParts(date).find((part) => part.type === "hour")?.value;
  const parsed = Number.parseInt(hour ?? "0", 10);
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function greetingKey(hour: number): "dashboard.greetingMorning" | "dashboard.greetingAfternoon" | "dashboard.greetingEvening" {
  if (hour < 12) return "dashboard.greetingMorning";
  if (hour < 18) return "dashboard.greetingAfternoon";
  return "dashboard.greetingEvening";
}
